import ServiceExec from '@/common/utils/ServiceExec';
import { inquiry } from '@/common/service/apiList';
import { cloneDeep } from 'lodash';
import { fileRequestBinding } from '@/common/utils/module/FormattingSupport';
import { asFormData } from '@/common/utils/module/FormDataSupport';
import store from '@/store';

export default {
  getInquiryList: async function({ state, commit, getters }) {
    const condition = getters['getCondition'];
    const currentPageInfo = getters['getPageInfo'];
    const { userNo } = store.getters['user/getUserData'];

    if (condition.page > currentPageInfo.totalPage) return false;
    condition.userNo = userNo;

    const { data, status } = await ServiceExec.get(inquiry.getList, condition);
    if (ServiceExec.status.OK !== status) return false;

    const { list, pageInfo } = data;
    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setPageInfo', pageInfo);
    commit('setInquiryList', list ?? []);
  },

  async getDetail({ commit, getters, state }, inquiryNo) {
    const { data, status } = await ServiceExec.get(inquiry.getDetail + inquiryNo);
    if (ServiceExec.status.OK !== status) return;
    commit('setDetail', data ?? '');
  },
  async addInquiry({ commit, getters, state }, payload) {
    const { userNo } = store.getters['user/getUserData'];
    const reqData = cloneDeep({ ...payload, userNo });
    fileRequestBinding(reqData);
    const formData = asFormData(reqData);
    const { status } = await ServiceExec.multiPost(inquiry.addInquiry, formData);
    return ServiceExec.status.OK === status;
  }
};
